import styled, { css } from 'styled-components'

import { NetworkIcon } from '@root/entities/network/ui'
import { AmountFormatted } from '@root/shared/core/format'
import { mediaMaxDesktopSmall } from '@root/shared/ui-kit'

import type { Network } from '@root/entities/network'
import type BigNumber from 'bignumber.js'

type Props = {
  balanceUsd: BigNumber | undefined
  balanceNative: BigNumber | undefined
  network: Network.Network
  iconSize: number
  withSeparator: boolean
}

export const WalletsBalanceCell: React.FC<Props> = ({
  balanceUsd,
  balanceNative,
  network,
  iconSize,
  withSeparator,
}) => {
  return (
    <Root>
      {balanceNative ? (
        <BalanceNative
          iconSize={iconSize}
          balanceNative={balanceNative}
          network={network}
        />
      ) : undefined}
      {withSeparator ? <Separator /> : undefined}
      {balanceUsd ? (
        <BalanceUsd>
          <AmountFormatted
            currency="$"
            amount={balanceUsd}
            roundingMode="trunc"
          />
        </BalanceUsd>
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
  font-size: 12px;

  ${mediaMaxDesktopSmall(css`
    grid-auto-flow: row;
    gap: 2px;
    justify-items: end;
  `)}
`

const BalanceUsd = styled.div`
  color: var(--text-9);
  font-weight: 600;
  font-size: 1em;
  line-height: 16px;
`

const Separator = styled.div`
  width: 1px;
  height: 18px;
  background-color: var(--background-2);
`

const BalanceNative = ({
  balanceNative,
  network,
  iconSize,
}: {
  iconSize: number
  balanceNative: BigNumber
  network: Network.Network
}) => {
  return (
    <BalanceNativeRoot>
      <NetworkIcon network={network} size={iconSize} />

      <AmountFormatted amount={balanceNative} roundingMode="trunc" />
    </BalanceNativeRoot>
  )
}

const BalanceNativeRoot = styled.div`
  color: var(--text-12);
  font-weight: 600;
  font-size: 1em;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 5px;

  ${mediaMaxDesktopSmall(css`
    gap: 3px;
  `)}
`
